
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/media/mediabank/[slug]",
      function () {
        return require("private-next-pages/media/mediabank/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/media/mediabank/[slug]"])
      });
    }
  